import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TokenInterceptorService implements HttpInterceptor {
  private static lastTokenCheck = 0;
  private static cachedToken: string | null = null;

  constructor(private oidcSecurityService: OidcSecurityService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Get cached token if recent (within 1 second) to prevent rapid checks
    let accessToken: string | null = null;
    const now = Date.now();

    if (
      now - TokenInterceptorService.lastTokenCheck < 1000 &&
      TokenInterceptorService.cachedToken
    ) {
      accessToken = TokenInterceptorService.cachedToken;
    } else {
      // Check both sessionStorage and localStorage for access token
      accessToken =
        sessionStorage.getItem('access_token') ||
        localStorage.getItem('access_token');

      // Cache the token and timestamp
      TokenInterceptorService.cachedToken = accessToken;
      TokenInterceptorService.lastTokenCheck = now;
    }

    let headers = req.headers;
    if (accessToken) {
      headers = headers.set('Authorization', `Bearer ${accessToken}`);
    }

    if (environment.apiKey) {
      headers = headers.set('apiKey', environment.apiKey);
    }

    if (req.url.includes('/adfs/oauth2/token')) {
      headers = headers.set(
        'Content-Type',
        'application/x-www-form-urlencoded'
      );
    }
    const modifiedReq = req.clone({ headers });
    return next.handle(modifiedReq);
  }
}
